import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.854 4.854l.798.798c.187.187.348.57.348.843v4.81c0 .275-.158.653-.354.849l-9.23 9.23a2.005 2.005 0 0 1-2.83.002l-5.972-5.972a2 2 0 0 1 .002-2.83l9.23-9.23c.199-.199.582-.354.862-.354h4.67a1.5 1.5 0 0 1 1.061.44l.061.06-2.014 2.014a2.753 2.753 0 0 0-3.43 2.651 2.754 2.754 0 1 0 5.508 0 2.748 2.748 0 0 0-.482-1.539L16.2 8.508a.505.505 0 0 1-.709 0 .507.507 0 0 1 .001-.708l6.448-6.448a.505.505 0 0 1 .71-.001c.19.19.194.513-.002.709l-2.794 2.794z"
});

var SvgCouponsFilled = function SvgCouponsFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCouponsFilled;